"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapCanBeReserved = void 0;
var _internal = require("../utils/internal");
var _constants = require("./constants");
const mapCanBeReserved = labels => labels?.find((0, _internal.findLabelByKey)(_constants.LABEL_CAN_BE_RESERVED)) !== undefined;
exports.mapCanBeReserved = mapCanBeReserved;
//# sourceMappingURL=mapCanBeReserved.js.map